/**
 * Static-translations for ro. Generated from:
 *  - `online/lang/static-translations.ts` (legacy, via KEY_MAP)
 *  - `tools/sdk-translations.mjs` (SDK-specific strings)
 *
 * Do not edit by hand — changes are lost on the next `node tools/gen-locales.mjs`.
 * To fix a translation, edit legacy/sdk-translations.mjs and regenerate.
 */
const ro = {
  'anon.heading_default': 'Continuă ca invitat',
  'anon.try_again': 'Încearcă din nou',
  'auth.back_to_login': 'Înapoi la autentificare',
  'auth.check_email_message': 'Verifică-ți e-mailul — am trimis un cod de confirmare.',
  'auth.check_email_title': 'Verifică-ți e-mailul',
  'auth.confirm_email_title': 'Confirmă-ți e-mailul',
  'auth.confirmation_code': 'Cod de confirmare',
  'auth.continue_with_apple': 'Continuă cu Apple',
  'auth.continue_with_facebook': 'Continuă cu Facebook',
  'auth.continue_with_github': 'Continuă cu GitHub',
  'auth.continue_with_google': 'Continuă cu Google',
  'auth.create_account': 'Creează cont',
  'auth.default_subtitle': 'Autentifică-te pentru a accesa toate funcțiile și sincroniza datele.',
  'auth.email': 'Adresă de e-mail',
  'auth.email_already_registered': 'Acest e-mail este deja înregistrat. Conectează-te mai jos cu parola sau contul folosit la înregistrare.',
  'auth.email_exists': 'Există deja un cont cu acest e-mail.',
  'auth.email_not_confirmed': 'Te rugăm să-ți confirmi mai întâi e-mailul.',
  'auth.forgot_password': 'Ai uitat parola?',
  'auth.forgot_password_title': 'Ai uitat parola?',
  'auth.forgot_subtitle': 'Introdu adresa de e-mail și îți vom trimite un link de resetare a parolei.',
  'auth.generic_error': 'Ceva nu a mers bine',
  'auth.have_account': 'Ai deja cont?',
  'auth.hide_password': 'Ascunde parola',
  'auth.identity_already_linked': 'Acest cont este deja înregistrat. Conectează-te cu el mai jos.',
  'auth.invalid_credentials': 'E-mail sau parolă incorecte',
  'auth.invalid_otp': 'Codul este invalid sau expirat.',
  'auth.last_used': 'Ultima dată · {email}',
  'auth.last_used_no_email': 'Ultima dată',
  'auth.link_purchase_subheading': 'Vom asocia achiziția cu contul tău pentru a păstra accesul.',
  'auth.log_in': 'Autentifică-te',
  'auth.log_in_link': 'Autentifică-te',
  'auth.login_continue_purchase': 'Autentifică-te pentru a continua achiziția',
  'auth.network_error': 'Eroare de rețea. Verifică conexiunea și încearcă din nou.',
  'auth.no_account': 'Nu ai cont?',
  'auth.or': 'sau',
  'auth.password': 'Parolă',
  'auth.passwords_mismatch': 'Parolele nu se potrivesc',
  'auth.rate_limited': 'Prea multe cereri. Încearcă din nou mai târziu.',
  'auth.repeat_password': 'Repetă parola',
  'auth.reset_link_valid': 'Linkul este valabil 1 oră.',
  'auth.reset_password_title': 'Resetare parolă',
  'auth.reset_sent_message': 'Dacă acel e-mail există, a fost trimis un cod de resetare.',
  'auth.reset_sent_subtitle': 'Am trimis un link pentru resetarea parolei. Urmează instrucțiunile din e-mail.',
  'auth.restore_purchases_heading': 'Restabilește achizițiile',
  'auth.restore_purchases_subheading': 'Autentifică-te pentru a-ți restabili achizițiile.',
  'auth.send_reset': 'Trimite e-mail de resetare',
  'auth.service_unavailable': 'Serviciu temporar indisponibil. Încearcă mai târziu.',
  'auth.show_password': 'Afișează parola',
  'auth.sign_out': 'Deconectare',
  'auth.sign_up': 'Înregistrează-te',
  'auth.sign_up_link': 'Înregistrează-te',
  'auth.signed_in': 'Conectat',
  'auth.signin_failed': 'Conectare eșuată',
  'auth.signup_failed': 'Înregistrarea a eșuat',
  'auth.verify': 'Verifică',
  'auth.weak_password': 'Parola este prea slabă.',
  'auth.welcome': 'Bun venit!',
  'auth.welcome_signup': 'Bun venit!',
  'cta.close': 'Închide',
  'cta.continue': 'Continuă',
  'cta.get_lifetime_access': 'Obține acces pe viață',
  'cta.get_plan_daily': 'Obține plan zilnic',
  'cta.get_plan_monthly': 'Obține plan lunar',
  'cta.get_plan_weekly': 'Obține plan săptămânal',
  'cta.get_plan_yearly': 'Obține plan anual',
  'cta.start_trial': 'Începe perioada de probă gratuită de {days} zile',
  'modal.close_aria': 'Închide',
  'modal.continue': 'Continuă',
  'modal.error_generic': 'Ceva nu a mers bine',
  'modal.loading': 'Se încarcă…',
  'modal.purchase_restored_subtitle': 'Totul e gata — bucură-te!',
  'modal.purchase_restored_title': 'Bine ai revenit',
  'modal.purchase_success_subtitle': 'Totul e gata — bucură-te!',
  'modal.purchase_success_title': 'Plată primită',
  'modal.verifying_subscription': 'Se verifică abonamentul…',
  'nav.back': '← Înapoi',
  'nav.back_aria': 'Înapoi',
  'offer.limited_time': 'Ofertă pe timp limitat',
  'payment.awaiting_title': 'Finalizează plata în noua filă',
  'payment.checking': 'Se verifică…',
  'payment.ive_paid': 'Am plătit',
  'payment.open_checkout_again': 'Deschide plata din nou',
  'payment.open_checkout_button': 'Deschide plata',
  'pricing.free_trial_days': '{days} zile probă gratuită',
  'pricing.included_per': 'Inclus pe {interval}:',
  'pricing.interval.day': 'zi',
  'pricing.interval.lifetime_short': 'pe viață',
  'pricing.interval.month': 'lună',
  'pricing.interval.period': 'perioadă',
  'pricing.interval.week': 'săptămână',
  'pricing.interval.year': 'an',
  'pricing.money_back': 'Garanție de returnare a banilor de 30 de zile',
  'pricing.most_popular': 'Cel mai popular',
  'pricing.no_prices': 'Niciun preț disponibil.',
  'pricing.plan_label.daily': 'PLAN ZILNIC',
  'pricing.plan_label.lifetime': 'pe viață',
  'pricing.plan_label.monthly': 'plan lunar',
  'pricing.plan_label.weekly': 'plan săptămânal',
  'pricing.plan_label.yearly': 'plan anual',
  'pricing.plans_aria': 'Planuri',
  'session.contact_support': 'Contactează suportul',
  'session.restore_purchases': 'Restabilește achizițiile',
  'session.sign_out': 'Deconectare',
  'session.signed_in_as_prefix': 'Conectat ca',
  'session.signing_out': 'Deconectare…',
  'support.attachments_label': 'Atașamente',
  'support.close_button': 'Închide',
  'support.done_button': 'Gata',
  'support.email_placeholder': 'Introdu e-mailul tău',
  'support.heading': 'Suport',
  'support.instruction': 'Te rugăm să completezi formularul de mai jos pentru a trimite cererea de suport.',
  'support.invalid_email': 'E-mail invalid',
  'support.message_length': '1–5000 caractere',
  'support.message_placeholder': 'Introdu mesajul',
  'support.required': 'Obligatoriu',
  'support.send_another': 'Trimite o altă cerere',
  'support.send_button': 'Trimite',
  'support.sending': 'Se trimite…',
  'support.subject_length': '3–200 caractere',
  'support.subject_placeholder': 'Introdu subiectul',
  'support.success_heading': 'Cerere trimisă',
  'support.success_message_prefix': 'Am primit mesajul tău și vom răspunde la'
} as const;

export default ro;
